import { getMinorBreakDefaultRequest, saveMinorBreakDefaultRequest } from 'api/requests/contract-compliance-requests';
import { MinorBreakRule } from 'constants/MinorBreakRule';
import { IMinorBreakRuleDefault, ISaveMinorBreakDefault } from 'types/contract-compliance/IContractCompliance';
import { RuleDefaultAdapter } from '../hooks/useRuleDefaultPanel';
import { DefaultDraft, toDefaultDraft, toSaveDefaultBody, validateDefaultDraft } from './utils';

export const minorBreakDefaultAdapter: RuleDefaultAdapter<
  MinorBreakRule,
  IMinorBreakRuleDefault,
  DefaultDraft,
  ISaveMinorBreakDefault
> = {
  emptyDraft: { threshold: '', minimumBreak: '', continuousBreak: '' },
  load: getMinorBreakDefaultRequest,
  save: saveMinorBreakDefaultRequest,
  toDraft: toDefaultDraft,
  validate: validateDefaultDraft,
  isComplete: (rule, draft) =>
    draft.threshold.trim() !== '' &&
    draft.minimumBreak.trim() !== '' &&
    (rule !== MinorBreakRule.LEGAL_WORK_TIME || draft.continuousBreak.trim() !== ''),
  toBody: toSaveDefaultBody,
};
